module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/formupload/asset/add.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/formupload/asset/add.png
// module id = 1064
// module chunks = 418